import { cva } from '@/styled-system/css';

export const progressStepperStepLabelTextRecipe = cva({
  base: { display: 'block' },
  variants: {
    interactive: {
      true: {
        'textStyle': 'body-sm-bold',
        'a:is(:hover) &, a:is(:hover) &': {
          textDecoration: 'underline',
        },
      },
      false: {
        textStyle: 'body-sm',
      },
    },
    active: {
      true: {
        textStyle: 'body-sm-bold',
      },
      false: {},
    },
    variant: {
      complete: {},
      incomplete: {},
      critical: {},
      warning: {},
      notStarted: {},
      active: {},
      none: {},
    },
  },
  compoundVariants: [
    // Interactive = false
    {
      interactive: false,
      active: true,
      css: {
        textStyle: 'body-sm-bold',
        color: 'text.neutral',
      },
    },
    {
      interactive: false,
      variant: 'complete',
      active: false,
      css: {
        color: 'ProgressMeter.Label.static.complete',
      },
    },
    {
      interactive: false,
      variant: 'critical',
      active: false,
      css: {
        color: 'ProgressMeter.Label.static.error',
      },
    },
    {
      interactive: false,
      variant: 'incomplete',
      active: false,
      css: {
        color: 'ProgressMeter.Label.static.incomplete',
      },
    },
    {
      interactive: false,
      variant: 'warning',
      active: false,
      css: {
        color: 'ProgressMeter.Label.static.warning',
      },
    },
    {
      interactive: false,
      variant: 'notStarted',
      active: false,
      css: {
        color: 'text.subtle',
      },
    },
    // Interactive = true
    {
      interactive: true,
      active: true,
      css: {
        'color': 'text.neutral',
        'a:is(:hover) &, a:is(:hover) &': {
          color: 'text.neutral',
        },
        'a:is(:active) &': {
          color: 'text.neutral',
        },
      },
    },
    {
      interactive: true,
      active: false,
      css: {
        'color': 'ProgressMeter.Label.interactive.default',
        'a:is(:hover) &, a:is(:hover) &': {
          color: 'ProgressMeter.Label.interactive.hover',
        },
        'a:is(:active) &, a:is(:active) &': {
          color: 'ProgressMeter.Label.interactive.pressed',
        },
      },
    },
  ],
});
